import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '@markant-platform/shared/data-access';
import { map, Observable } from 'rxjs';
import { Campaign } from '@markant-platform/campaign/model';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private readonly campaignApiUrl = AppConfigService.appConfiguration.apiUrl['campaign'];

  private readonly http = inject(HttpClient);

  getPublicCampaignData(campaignId: string): Observable<Campaign> {
    return this.http.get<Campaign>(`${this.campaignApiUrl}/${campaignId}`);
  }
  getServiceConditions(campaignId: string): Observable<string> {
    return this.http
      .get(`${this.campaignApiUrl}/${campaignId}/service-conditions`, {
        headers: new HttpHeaders({ Accept: 'application/octet-stream' }),
        responseType: 'blob',
      })
      .pipe(
        map((octetStreamBlob: Blob) =>
          // recreate blob to set type to application/pdf to let the browser know that it is a pdf
          URL.createObjectURL(new Blob([octetStreamBlob], { type: 'application/pdf' }))
        )
      );
  }
}
